export default __webpack_public_path__ + "6f430d319af7e235f14c7275b9ed600a.png";